var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "row-card" }, [
    _c(
      "div",
      { staticClass: "flex-row header flex-1 mr-1 ml-1 pl-1 pt-1 pr-1 pb-1" },
      [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.isHeader,
                expression: "!isHeader",
              },
            ],
            staticClass: "flex-col",
          },
          [
            _c(
              "div",
              { staticClass: "settings-icon" },
              [_c("font-awesome-icon", { attrs: { icon: ["fas", "cogs"] } })],
              1
            ),
          ]
        ),
        _c(
          "div",
          {
            staticClass:
              "flex-col flex-4 flex-justify-center ml-4 mr-5 pr-4 pl-2",
          },
          [_vm._t("title")],
          2
        ),
        _c("span", { staticClass: "separator ml-6 mr-4" }),
        _c(
          "div",
          { staticClass: "flex-col flex-justify-center flex-3" },
          [_vm._t("value")],
          2
        ),
        _c("span", { staticClass: "separator ml-4 mr-4" }),
        _c(
          "div",
          { staticClass: "flex-col flex-justify-center flex-1" },
          [_vm._t("buttons")],
          2
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }